import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import { generateRandomNonce } from '../../utils/utils';
import { getBrowserLanguage } from '../../store/slices/languageSlice';

const screen_hint = 'signin';

const Login = () => {
  const { loginWithRedirect } = useAuth0();
  const { idp } = useParams<{ idp?: string }>();

  let locale = getBrowserLanguage();

  // get lng param from url
  const urlSearchParams = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(urlSearchParams.entries());
  if (queryParams.lng) locale = queryParams.lng as string;

  const nonce = generateRandomNonce();
  const state = JSON.stringify({ nonce });

  useEffect(() => {
    localStorage.setItem('nonce', nonce);
  }, [nonce]);

  useEffect(() => {
    if (idp) {
      loginWithRedirect({
        connection: idp,
        screen_hint,
        state,
        ui_locales: locale,
      });
    } else {
      loginWithRedirect({
        screen_hint,
        state,
        ui_locales: locale,
      });
    }
  }, [idp]);

  return null;
};

export default Login;
